import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, last } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { IAssetResponse } from '../models/IAssetResponce';
import { IBlobResult } from '../models/IBlobResult';
import { environment } from 'environments/environment';


@Injectable()
export class HttpService {

    constructor(private http: HttpClient,
        private router: Router,
        private localStorage: LocalStorageService) {
    }

    getHeaders() {
        const headersAdditional = new HttpHeaders();
        headersAdditional.append('Cache-control', 'no-cache');
        headersAdditional.append('Cache-control', 'no-store');
        headersAdditional.append('Expires', '0');
        headersAdditional.append('Pragma', 'no-cache');
        headersAdditional.append('Content-Type', 'application/json');
        return { headers: headersAdditional };
    }

    get<T>(url: string): Observable<T> {
        const timeStamp = +new Date();
        const uniqueUrl = url + (/\?/.test(url) ? '&tsp' : '?tsp=') + timeStamp;

        return this.http
            .get<T>(`${environment.apiUrl}/api/${uniqueUrl}`, this.getHeaders())
            .pipe(catchError(this.handleError<T>('api:get' + url)));
    }

    post(url: string, model): Observable<any> {
        return this.http.post(`${environment.apiUrl}/api/${url}`, model, this.getHeaders())
            .pipe(catchError(this.handleError('api:get' + url)));
    }

    put(url: string, model): Observable<any> {
        return this.http.put(`${environment.apiUrl}/api/${url}`, model, this.getHeaders())
            .pipe(catchError(this.handleError('api:get' + url)));
    }

    delete(url: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/api/${url}`, this.getHeaders())
            .pipe(catchError(this.handleError('api:get' + url)));
    }

    uploadAsset(url: string, file: FormData): Observable<IAssetResponse> {
        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: false,
        };

        const req = new HttpRequest('POST', `${environment.apiUrl}/api/${url}`, file, options);
        return this.http.request(req)
            .pipe(last(), catchError(this.handleError('api:get' + url)))
            .map((res: HttpResponse<IAssetResponse>) => res.body);
    }

    export(url): Observable<IBlobResult> {
        return Observable.create(observer => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `${environment.apiUrl}/api/` + url, true);
            const token = `Bearer ${this.localStorage.get('token')}`;
            xhr.setRequestHeader('Authorization', token);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.responseType = 'blob';

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const fileName = xhr.getResponseHeader('content-disposition').split(';')[1].trim().split('=')[1];
                        const result = {
                            blob: new Blob([xhr.response], { type: contentType }),
                            fileName: fileName.replace(/"/g, '')
                        };
                        observer.next(result);
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };

            xhr.send();
        });
    }

    private handleError<T>(operations = 'operation') {
        return (error: any): Observable<T> => {
            if (error.status === 403) {
                this.router.navigate(['/admin/access-denied']);
            }
            if (error.status === 401) {
                this.localStorage.set('user-roles', null);
                this.localStorage.set('user-identity', null);
                this.localStorage.set('token', '');

                this.router.navigate(['/signin']);
            }
            return Observable.throw(error);
        };
    }

}

